export default "__VITE_ASSET__Dc6nn4BZ__"